// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "terminal-2JIt2";
var _3 = "weather__temperature-1Iggs";
var _4 = "point-3kaI1";
var _5 = "airportName-2hb_c";
var _6 = "duration-3aZYf";
var _7 = "points-3BCFV";
var _8 = "weather-2e92V";
var _9 = "amenities_available-1PNmJ";
var _a = "amenities_unavailable-2LjKl";
var _b = "segment__link-2pFgN";
var _c = "segment__plane-2HKnd";
var _d = "segment__airline-3BzjZ";
var _e = "flight-17x4K";
export { _1 as "__esModule", _2 as "terminal", _3 as "weather__temperature", _4 as "point", _5 as "airportName", _6 as "duration", _7 as "points", _8 as "weather", _9 as "amenities_available", _a as "amenities_unavailable", _b as "segment__link", _c as "segment__plane", _d as "segment__airline", _e as "flight" }
export default { "__esModule": _1, "terminal": _2, "weather__temperature": _3, "point": _4, "airportName": _5, "duration": _6, "points": _7, "weather": _8, "amenities_available": _9, "amenities_unavailable": _a, "segment__link": _b, "segment__plane": _c, "segment__airline": _d, "flight": _e }
